module.exports = __webpack_public_path__ + "static/media/silva-win.c02ee1b8.png";